import { render, staticRenderFns } from "./FunFacts.vue?vue&type=template&id=190900b2&scoped=true&"
import script from "./FunFacts.vue?vue&type=script&lang=js&"
export * from "./FunFacts.vue?vue&type=script&lang=js&"
import style0 from "./FunFacts.vue?vue&type=style&index=0&id=190900b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190900b2",
  null
  
)

export default component.exports